<template>
  <b-card>
      <!-- Form -->
      <b-form
        class="p-2"
      >
        <b-row>
        <b-col sm="12">
          <b-form-group
            label="Nama"
            label-for="nama"
          >
            <b-form-input
              v-model="userData.nama"
              name="nama"
              placeholder="nama"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="NIP"
            label-for="nip"
          >
            <b-form-input
              v-model="userData.nip"
              name="nip"
              placeholder="NIP"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="NIDN"
            label-for="nidn"
          >
            <b-form-input
              v-model="userData.nidn"
              name="nidn"
              placeholder="NIDN"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="HRIS"
            label-for="hris"
          >
            <b-form-input
              v-model="userData.hris"
              name="hris"
              placeholder="HRIS"
              type="text"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Status Kepegawaian"
            label-for="status_kepegawaian"
          >
            <b-form-input
              v-model="userData.status_kepegawaian"
              name="status_kepegawaian"
              placeholder="Status kepegawaian"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Fungsi Jabatan"
            label-for="fungsi_jabatan"
          >
            <b-form-input
              v-model="userData.fungsi_jabatan"
              name="fungsi_jabatan"
              placeholder="Fungsi Jabatan"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Pangkat"
            label-for="pangkat"
          >
            <b-form-input
              v-model="userData.pangkat"
              name="pangkat"
              placeholder="Pangkat"
            />
          </b-form-group>
        </b-col>
        <b-col sm="12">
          <b-form-group
            label="Golongan"
            label-for="golongan"
          >
            <b-form-input
              v-model="userData.golongan"
              name="golongan"
              placeholder="Golongan"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Prodi"
            label-for="prodi"
          >
            <b-form-input
              v-model="userData.prodi"
              name="prodi"
              placeholder="Prodi"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="Pendidikan"
            label-for="pendidikan"
          >
            <b-form-input
              v-model="userData.pendidikan"
              name="pendidikan"
              placeholder="Pendidikan"
            />
          </b-form-group>
        </b-col>
         <b-col sm="12">
          <b-form-group
            label="No Serdos"
            label-for="No Serdos"
          >
            <b-form-input
              v-model="userData.no_serdos"
              name="No Serdos"
              placeholder="No Serdos"
            />
          </b-form-group>
        </b-col>
      </b-row>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            @click="updateData"
          >
            Simpan
          </b-button>
        </div>

      </b-form>
  </b-card>
</template>

<script>
import {
  BCard, BButton, BAvatar, BRow, BCol, BBadge,
  BForm, BFormGroup, BFormInput, BFormInvalidFeedback,
  BFormSpinbutton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { ref } from '@vue/composition-api'
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import {
  getUPT,
} from '@/connection-api/master'
import { required, alphaNum, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import { avatarText } from '@core/utils/filter'
import useList from '@/connection-api/pengguna/list'
import moment from 'moment'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    var userData = this.rowData.data
    return {
      userData,
      required,
      alphaNum,
      email,
      configs: {
        basic: {},
        wrap: {
          wrap: true,
          altFormat: 'M j, Y',
          altInput: true,
          dateFormat: 'Y-m-d',
        },
      },
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async updateData() {
      store.dispatch('dosen/updateData', this.rowData.data)
        .then(response => {
          this.makeToast('success', 'Simpan Data Dosen Berhasil Dilakukan')
          setTimeout(() => {
            this.$router.push({name: 'dosen'})
          }, 3000);
        })
        .catch(error => {
        })
    },
    formatPrice(value) {
      const val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    formatDate(value, format) {
      return moment(String(value)).format(format)
    },
    makeToast(variant = null, message = null) {
      this.$bvToast.toast(message, {
        // title: `Variant ${variant || 'default'}`,
        title: 'Dosen',
        variant,
        solid: true,
        autoHideDelay: 3000,
      })
    },
    mappingSelectOptionIds(master, name) {
      if (master.length > 0) {
        master.forEach(element => {
          name.push({
            label: element.nama,
            value: element.ids,
          })
        })
      }
    },
  },
}
</script>

<style>

</style>
